// * Bootstrap libraries
import './_bootstrap';
import "./_dropdown-hover";
import "./_org-chart";

(function ($, Drupal, once) {
  'use strict';


  //Fixed menu on scroll
  document.addEventListener('DOMContentLoaded', function() {
    var navbar = document.getElementById("navigation");

    // Vérifier que l'élément existe avant de continuer
    if (!navbar) {
      console.warn('Élément #navigation non trouvé');
      return;
    }

    var sticky = navbar.offsetTop;

    function myFunctionForSticky() {
      if (window.pageYOffset >= sticky) {
        navbar.classList.add("sticky");
      } else {
        navbar.classList.remove("sticky");
      }
    }

    window.addEventListener('scroll', myFunctionForSticky);
  });
  /*const formatPostDetails = (postElement) => {
    const $post = $(postElement);
    const title = $post.find('.titre').text();
    const description = $post.find('.description').text();
    const lien = $post.find('.lien').text();
    const image = $post.find('.image img').attr('src');

    return `<div class="row">
                        <div class="col-sm-6">
                            <h3 class="titre">${title}</h3>
                            <p class="description">${description}</p>
                            <a href="${lien}">En savoir plus</a>
                        </div>
                        <div class="col-sm-6">
                            <img src="${image}" alt="${title}" class="image"/>
                        </div>
                    </div>`;
  };*/
  Drupal.behaviors.customScripts = {
    attach: function (context, _settings) {
      // Désactivation simple en mode admin
      if (window.location.pathname.includes('/admin')) {
        return;
      }

      once('custom-scripts', 'body', context).forEach(function() {

        // Vérifier que Swiper est disponible
        if (typeof Swiper === 'undefined') {
          console.error('Swiper n\'est pas chargé');
          return;
        }

        // Fonction helper pour initialiser un Swiper avec vérification
        function initSwiper(selector, config) {
          const element = document.querySelector(selector);
          if (element && !element.swiper) {
            return new Swiper(selector, config);
          }
          return null;
        }

        // Slider membres
        initSwiper('.membres-swiper', {
          slidesPerView: 6,
          spaceBetween: 30,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          breakpoints: {
            1200: { slidesPerView: 6 },
            992: { slidesPerView: 4 },
            650: { slidesPerView: 2 },
            0: { slidesPerView: 1 }
          }
        });
         //spiper rse

        initSwiper(".rse-gallerie .engagements-concret  .views-field-field-gallerie .field-content", {
          slidesPerView: 4,
          observer: true,
          createElements: true,
          autoplay:true,
          grid: {
            rows: 1,
          },
          spaceBetween: 30,
          navigation: {
            nextEl: '.rse-gallerie .engagements-concret .swiper-button-next',
            prevEl: '.rse-gallerie .engagements-concret .swiper-button-prev',
          },
          breakpoints: {
            1200: {
              slidesPerView: 4
            },
            992: {
              slidesPerView: 3
            },
            500: {
              slidesPerView: 2
            },
            0: {
              slidesPerView: 1
            }
          }
        });

        initSwiper(".rse-gallerie .partenariat-ecobank  .views-field-field-gallerie .field-content", {
          slidesPerView: 4,
          observer: true,
          createElements: true,
          grid: {
            rows: 1,
          },
          spaceBetween: 30,
          navigation: {
            nextEl: '.rse-gallerie .partenariat-ecobank  .swiper-button-next',
            prevEl: '.rse-gallerie .partenariat-ecobank  .swiper-button-prev',
          },
          breakpoints: {
            1200: {
              slidesPerView: 4
            },
            992: {
              slidesPerView: 3
            },
            500: {
              slidesPerView: 2
            },
            0: {
              slidesPerView: 1
            }
          }
        });

        initSwiper(".rse-gallerie .inclusion  .views-field-field-gallerie .field-content", {
          slidesPerView: 4,
          observer: true,
          createElements: true,
          grid: {
            rows: 1,
          },
          spaceBetween: 30,
          navigation: {
            nextEl: '.rse-gallerie .inclusion  .swiper-button-next',
            prevEl: '.rse-gallerie .inclusion  .swiper-button-prev',
          },
          breakpoints: {
            1200: {
              slidesPerView: 4
            },
            992: {
              slidesPerView: 3
            },
            500: {
              slidesPerView: 2
            },
            0: {
              slidesPerView: 1
            }
          }
        });
        initSwiper(".rse-gallerie .benin-artisan  .views-field-field-gallerie .field-content", {
          slidesPerView: 4,
          observer: true,
          createElements: true,
          grid: {
            rows: 1,
          },
          spaceBetween: 30,
          navigation: {
            nextEl: '.rse-gallerie .benin-artisan  .swiper-button-next',
            prevEl: '.rse-gallerie .benin-artisan  .swiper-button-prev',
          },
          breakpoints: {
            1200: {
              slidesPerView: 4
            },
            992: {
              slidesPerView: 3
            },
            500: {
              slidesPerView: 2
            },
            0: {
              slidesPerView: 1
            }
          }
        });

        initSwiper(".rse-gallerie .senegal-artisan  .views-field-field-gallerie .field-content", {
          slidesPerView: 4,
          observer: true,
          createElements: true,
          grid: {
            rows: 1,
          },
          spaceBetween: 30,
          navigation: {
            nextEl: '.rse-gallerie .senegal-artisan  .swiper-button-next',
            prevEl: '.rse-gallerie .senegal-artisan  .swiper-button-prev',
          },
          breakpoints: {
            1200: {
              slidesPerView: 4
            },
            992: {
              slidesPerView: 3
            },
            500: {
              slidesPerView: 2
            },
            0: {
              slidesPerView: 1
            }
          }
        });


        // Fonctions pour le slider home
        function initializeHomeSliderPagination(swiperInstance) {
          requestAnimationFrame(function() {
            const totalSlides = swiperInstance.slides.length;
            const currentSlide = swiperInstance.realIndex + 1;

            const paginationBar = document.querySelector('.sliderhome-swiper .swiper-pagination');
            const currentSlideEl = document.querySelector('.sliderhome-swiper .current-slide');
            const totalSlidesEl = document.querySelector('.sliderhome-swiper .total-slides');

            // Batch DOM updates
            if (paginationBar) {
              paginationBar.style.height = '120px';
            }
            if (currentSlideEl) {
              currentSlideEl.textContent = currentSlide.toString().padStart(2, '0');
            }
            if (totalSlidesEl) {
              totalSlidesEl.textContent = totalSlides.toString().padStart(2, '0');
            }
          });
        }

        function updateHomeSliderCurrentSlide(swiperInstance) {
          requestAnimationFrame(function() {
            const currentSlide = swiperInstance.realIndex + 1;
            const currentSlideEl = document.querySelector('.sliderhome-swiper .current-slide');

            if (currentSlideEl) {
              currentSlideEl.textContent = currentSlide.toString().padStart(2, '0');
            }
          });
        }

        // Slider page d'accueil
        initSwiper('.sliderhome-swiper', {
          slidesPerView: 1,
          spaceBetween: 30,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          on: {
            init: function () {
              initializeHomeSliderPagination(this);
            },
            slideChange: function () {
              updateHomeSliderCurrentSlide(this);
            }
          }
        });

        // Slider bloc salon monétique
        initSwiper('.exhibition-swiperxxx', {
          slidesPerView: 3,
          spaceBetween: 30,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: '.exhibition-swiperxxx .swiper-button-next',
            prevEl: '.exhibition-swiperxxx .swiper-button-prev'
          },
          breakpoints: {
            1200: { slidesPerView: 3 },
            992: { slidesPerView: 3 },
            650: { slidesPerView: 1 },
            0: { slidesPerView: 1 }
          }
        });

        // Slider bloc apropos
        initSwiper('.apropos-swiper', {
          slidesPerView: 'auto',
          spaceBetween: 20,
          centeredSlides: true,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: '.apropos-swiper .swiper-button-next',
            prevEl: '.apropos-swiper .swiper-button-prev',
          },
          pagination: {
            el: '.apropos-swiper .swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            1200: {
              slidesPerView: 'auto',
              spaceBetween: 20
            },
            992: {
              slidesPerView: 'auto',
              spaceBetween: 15
            },
            768: {
              slidesPerView: 'auto',
              spaceBetween: 10
            },
            0: {
              slidesPerView: 1.2,
              spaceBetween: 10,
              centeredSlides: true
            }
          }
        });

        // Slider apropos-bloc1
        /*initSwiper('.apropos-bloc1-swiper', {
          slidesPerView: 1,
          spaceBetween: 30,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          breakpoints: {
            1200: { slidesPerView: 1 },
            992: { slidesPerView: 1 },
            650: { slidesPerView: 1 },
            0: { slidesPerView: 1 }
          }
        });*/

        document.querySelectorAll('.block-field-blocknodeactualitesfield-description p a').forEach(function(link) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        });

        //document publier lien externe en new tab
        document.querySelectorAll('.view-publication .document a').forEach(function(link) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        });

        // Scroll texte bloc highlighted section
        if (typeof $.fn.marquee !== 'undefined') {
          const highlightedElement = $('.highlighted-section .block .field--name-body');
          if (highlightedElement.length && !highlightedElement.data('marquee-initialized')) {
            if (!$.trim) {
              $.trim = function(text) {
                return text == null ? "" : (text + "").replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
              };
            }
            highlightedElement.marquee({
              duration: 25000,
              duplicated: true,
              gap: 50
            });
            highlightedElement.data('marquee-initialized', true);
          }
        }




        // Swiper produit home page avec gestion optimisée
        /*const blockDetailProdElement = document.querySelector('.block_detail_prod-swiper');
        const $firstPost = $(context).find(".block_detail_prod-swiper .post").first();
        if ($firstPost.length) {
          const firstContentHtml = formatPostDetails($firstPost);
          $(".view-produits-et-services .view-header").html(firstContentHtml);
        }
        if (blockDetailProdElement && !blockDetailProdElement.swiper) {

          new Swiper(".block_detail_prod-swiper", {
            spaceBetween: 20,
            slidesPerView: 5,
            centeredSlides: true,
            centerInsufficientSlides: true,
            navigation: {
              nextEl: ".block_detail_prod-swiper .swiper-button-next",
              prevEl: ".block_detail_prod-swiper .swiper-button-prev",
            },
          });

          if (!window._gim_block_detail_prod_click_attached) {
            $(document).on('click', '.block_detail_prod-swiper .post', function(e) {
              e.preventDefault();
              const postEl = this;
              requestAnimationFrame(function() {
                const contenuHtml = formatPostDetails(postEl);
                $('.view-produits-et-services .view-header').html(contenuHtml);
              });
            });
            window._gim_block_detail_prod_click_attached = true;
          }
        }

        $(document).on('ajaxComplete', function(event, xhr, settings) {
          if (settings && settings.url && settings.url.indexOf('views/ajax') !== -1) {
            setTimeout(function() {
              const $first = $('.block_detail_prod-swiper .post').first();
              new Swiper(".block_detail_prod-swiper", {
                spaceBetween: 20,
                slidesPerView: 5,
                centeredSlides: true,
                centerInsufficientSlides: true,
                navigation: {
                  nextEl: ".block_detail_prod-swiper .swiper-button-next",
                  prevEl: ".block_detail_prod-swiper .swiper-button-prev",
                },
              });
              if ($first.length) {
                const html = formatPostDetails($first[0]);
                $('.view-produits-et-services .view-header').html(html);
              }
            }, 150);
          }
        });*/

        // Swiper événement
        initSwiper('.evenement-swiper', {
          slidesPerView: 3,
          spaceBetween: 30,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: '.evenement-swiper .swiper-button-next',
            prevEl: '.evenement-swiper .swiper-button-prev'
          },
          breakpoints: {
            1200: { slidesPerView: 3 },
            992: { slidesPerView: 3 },
            650: { slidesPerView: 1 },
            0: { slidesPerView: 1 }
          }
        });


        // Gestion des onglets pour node-73
        if ($('body').hasClass('node-73')) {
          const urlParams = new URLSearchParams(window.location.search);
          const code = urlParams.get('tab');
          if (code === 'bceao') {
            requestAnimationFrame(function() {
              $('#quicktabs-tab-bloc_liste_membres-1').addClass('active');
              //$('#quicktabs-tab-bloc_liste_membres-0').removeClass('active');

              setTimeout(function() {
                $('#quicktabs-tab-bloc_liste_membres-1 a').trigger('click');
              }, 100);
            });
          }
          //adhesion tab
          if (code === 'adhesion') {
            requestAnimationFrame(function() {
              $('#quicktabs-tab-bloc_liste_membres-2').addClass('active');
              //$('#quicktabs-tab-bloc_liste_membres-0').removeClass('active');

              setTimeout(function() {
                $('#quicktabs-tab-bloc_liste_membres-2 a').trigger('click');
              }, 100);
            });
          }
          //membre tab
          if (code === 'membres') {
            requestAnimationFrame(function() {
              $('#quicktabs-tab-bloc_liste_membres-0').addClass('active');
              //$('#quicktabs-tab-bloc_liste_membres-0').removeClass('active');

              setTimeout(function() {
                $('#quicktabs-tab-bloc_liste_membres-0 a').trigger('click');
              }, 100);
            });
          }
        }

        //page partenaires
        // Gestion des onglets pour node-73
        if ($('body').hasClass('node-229')) {
          const urlParams = new URLSearchParams(window.location.search);
          const code = urlParams.get('tab');
          if (code === 'liste_partenaires') {
            requestAnimationFrame(function() {
              $('#quicktabs-tab-bloc_partenaire-0').addClass('active');
              //$('#quicktabs-tab-bloc_liste_membres-0').removeClass('active');

              setTimeout(function() {
                $('#quicktabs-tab-bloc_partenaire-0 a').trigger('click');
              }, 100);
            });
          }
          //trigger bloc part agree
          if (code === 'partenaire_agree') {
            requestAnimationFrame(function() {
              $('#quicktabs-tab-bloc_partenaire-1').addClass('active');
              //$('#quicktabs-tab-bloc_liste_membres-0').removeClass('active');

              setTimeout(function() {
                $('#quicktabs-tab-bloc_partenaire-1 a').trigger('click');
              }, 100);
            });
          }
        }

        // Ajout des chevrons aux dropdowns avec requestAnimationFrame
        requestAnimationFrame(function() {
          document.querySelectorAll('.dropdown-toggle').forEach(function(toggle) {
            if (!toggle.querySelector('.fa-chevron-down')) {
              const icon = document.createElement('i');
              icon.className = 'fa-solid fa-chevron-down';
              icon.style.marginLeft = '5px';
              toggle.appendChild(icon);
            }
          });
        });

        // Placeholder recherche
        const searchInput = document.getElementById("edit-keys");
        if (searchInput && !searchInput.hasAttribute('placeholder')) {
          searchInput.placeholder = "Recherche";
        }


        //js pour controle email newsletter
        // Ajoute le conteneur d'erreur une seule fois sous le champ email
        if ($('#email-error--2').length === 0) {
          $('#edit-email--2').after('<div id="email-error--2" style="color:red; font-size:0.9em; margin-top:4px;"></div>');
        }

        const emailField = $('#edit-email--2');
        const errorDiv = $('#email-error--2');
        const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

// Validation au blur
        emailField.on('blur', validateEmailField);

// Validation au submit + blocage du formulaire si invalide
        emailField.closest('form').on('submit', function(e) {
          if (!validateEmailField()) {
            e.preventDefault();
            e.stopPropagation();
            emailField.focus();
          }
        });

// Fonction de validation
        function validateEmailField() {
          const email = emailField.val();
          if (!regex.test(email) && email.length > 0) {
            errorDiv.text("Veuillez saisir une adresse email valide.");
            return false;
          } else {
            errorDiv.text("");
            return true;
          }
        }

        // Placeholder recherche
        $("#edit-keys").attr('placeholder', 'Recherche');

            //code remove

        $('.views-exposed-form .js-form-item-field-banque-target-id .form-select option:contains("- Any -")'
        ).text("Banque");

      /*  $('.views-exposed-form .js-form-item-field-pays-target-id .form-select option:contains("- Any -")'
        ).text("Pays");
*/
        $('.views-exposed-form .js-form-item-field-ville-p-target-id .form-select option:contains("- Any -")'
        ).text("Ville");

        $('.views-exposed-form .js-form-item-field-localisation-target-id .form-select option:contains("- Any -")'
        ).text("Localisation");

        $('.views-exposed-form .js-form-item-field-type-de-contrat-value .form-select option:contains("- Any -")'
        ).text("Type de contrat");

        // Gestion toggle navbar mobile complète
        (function() {
          const toggler = document.querySelector(".navbar-toggler");
          const menu = document.getElementById("mainNavbar");

          if (toggler && menu && !toggler.__gim_navbar_attached) {
            toggler.__gim_navbar_attached = true;

            // Toggle du menu principal
            toggler.addEventListener("click", function(e) {
              e.preventDefault();
              const isOpen = menu.classList.contains("show");

              if (isOpen) {
                menu.classList.remove("show");
                toggler.setAttribute("aria-expanded", "false");
              } else {
                menu.classList.add("show");
                toggler.setAttribute("aria-expanded", "true");
              }
            });

            // Fermeture du menu lors du clic sur les liens internes
            document.querySelectorAll("#mainNavbar a").forEach(function(link) {
              if (!link.__gim_navbar_link_attached) {
                link.__gim_navbar_link_attached = true;

                link.addEventListener("click", function() {
                  menu.classList.remove("show");
                  toggler.setAttribute("aria-expanded", "false");
                });
              }
            });
          }
        })();

      });
    }
  };
})(jQuery, Drupal, once);
